exports.components = {
  "component---src-pages-special-offers-tsx": () => import("./../../../src/pages/special-offers.tsx" /* webpackChunkName: "component---src-pages-special-offers-tsx" */),
  "component---src-templates-case-tsx": () => import("./../../../src/templates/case.tsx" /* webpackChunkName: "component---src-templates-case-tsx" */),
  "component---src-templates-page-tsx": () => import("./../../../src/templates/page.tsx" /* webpackChunkName: "component---src-templates-page-tsx" */)
}

